export default "__VITE_ASSET__Xhjm$Nmp__"